<template>
  <div class="flex-col group_10 ml-35">
    <steps
      :step="step"
      :data="[
        {src: $images.step1, name: '资料上传' },
        {src: $images.step2, name: '正在审核' },
        {src: $images.step3, name: '申请结果' }
      ]"
    />
    <div class="flex-col mt-9">
      <div v-if="step == 1 || step == 2" class="mt-36 flex-col justify-start relative group_12">
        <div class="flex-col section_10 pos">
          <div class="flex-row items-center group_13">
            <p class="row">
              <span class="key">证书编号</span>
              <el-input class="value" placeholder="请输入证书编号" v-model="form.zsbh" :disabled="step != 1"></el-input>
            </p>
            <p class="row">
              <span class="key">发证机构名称</span>
              <el-input class="value" placeholder="请输入发证机构名称" v-model="form.jgmc" :disabled="step != 1"></el-input>
            </p>
            <p class="row">
              <span class="key">创新项目名称</span>
              <el-input class="value" placeholder="请输入创新项目名称" v-model="form.xmmc" :disabled="step != 1"></el-input>
            </p>
            <p class="row">
              <span class="key">获证企业名称</span>
              <el-input class="value" placeholder="请输入获证企业名称" v-model="form.qymc" :disabled="step != 1"></el-input>
            </p>
            <p class="row">
              <span class="key">认证对象</span>
              <el-input class="value" placeholder="认证对象" v-model="form.rzdx" :disabled="step != 1"></el-input>
            </p>
            <div class="row">
              <span class="key">证书上传</span>
              <div v-if="form.zs_name" class="ml-14 flex-col items-center section_11 upload-box">
                <p class="file-box">
                  <img v-if="form.zs.indexOf('.pdf') > -1" :src="pdfIcon" alt="img" />
                  <img
                    v-if="
                    form.zs.indexOf('.png') > -1
                    || form.zs.indexOf('.jpeg') > -1
                    || form.zs.indexOf('.jpg') > -1
                    " :src="$baseUrl + form.zs"
                    class="tupian"
                    alt="img" />
                  <span class="name">{{form.zs_name}}</span>
                </p>
                <span v-if="step == 1" class="word" @click="reUpload">重新上传</span>
              </div>
              <div v-show="!form.zs_name" class="ml-14 flex-col items-center section_11">
                <el-upload
                  ref="upload"
                  class="upload"
                  drag
                  action="#"
                  :file-list="fileList"
                  :http-request="uploadSubmit"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :before-upload="beforeUpload"
                  :disabled="step != 1"
                >
                </el-upload>
                <img
                  class="image_5"
                  :src="$images.upload"
                />
                <span class="mt-8 font_2 text_20">点击上传</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="step == 1" class="flex-row justify-end self-stretch group_20">
          <!-- <div class="flex-row items-center section_13">
            <img
              class="image_7"
              :src="$images.btnSave"
            />
            <span class="font_8 ml-9">暂存</span>
          </div> -->
          <div class="flex-col justify-start items-center text-wrapper_4 ml-31" @click="submit"><span class="font_9">完成</span></div>
        </div>
      </div>
      <div v-else class="result-box">
        <img :src="applyImg" alt="img" />
        <div class="box" :class="{success: state == 2}">
          <img :src="state == 2 ? applySuccessIcon : applyFailIcon" alt="" />
          <span class="word">{{state == 2 ? '审核通过' : '审核不通过'}}</span>
          <img class="img" :src="state == 2 ? applySuccess : applyFail" alt="" />
        </div>
        <div v-if="state == 3" class="reason">
          <span class="word">不通过原因：{{reason}}</span>
        </div>
      </div>
      <span v-if="`${state}` === '3'" class="btn">
        <span @click="handleReSubmit">重新修改</span>
      </span>
      <span v-if="`${state}` === '2'" class="btn">
        <span @click="handleReSubmit">再次申请</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    const {
      applyImg,
      applyFailIcon,
      applyFail,
      applySuccessIcon,
      applySuccess,
      pdfIcon
    } = this.$images
    return {
      applyImg,
      applyFailIcon,
      applyFail,
      applySuccessIcon,
      applySuccess,
      pdfIcon,
      state: 1, // 审核真实状态
      reason: '', // 不通过原因
      step: 1,
      fileList: [],
      form: {
        id: '',
        zsbh: '',
        jgmc: '',
        xmmc: '',
        qymc: '',
        rzdx: '',
        zs: ''
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      // 获取申请id
      const id = '' // localStorage.getItem('applyReportId')
      // if (id) {
      const res = await this.$https.getZsbgsqDetailById(id)
      const state = res.data.data.audit_state
      this.reason = res.data.data.reason
      if (state) {
        // 审核状态 1未审核 2审核通过 3审核不通过
        if (['1'].includes(`${state}`)) this.step = 2
        if (['2', '3'].includes(`${state}`)) this.step = 3
        this.state = state
      }
      this.form = res.data.data
      // }
    },
    reUpload () {
      const upload = this.$refs.upload
      upload.$el.querySelector('.el-upload__input').click()
    },
    async submit () {
      const res = await this.$https.zsbgsqSave(this.form)
      if (res.data.status) {
        this.$message.success('提交成功')
        localStorage.setItem('applyReportId', res.data.data.id)
        // 清空数据
        this.fileList = []
        this.form = {
          id: '',
          zsbh: '',
          jgmc: '',
          xmmc: '',
          qymc: '',
          rzdx: '',
          zs: ''
        }
        window.location.href = '/#/server?type=9'
        window.location.reload()
      } else {
        this.$message.error(res.data.msg)
      }
    },
    handleReSubmit () {
      this.step = 1
      this.state = 1
    },
    async uploadSubmit (options) {
      const { file } = options

      const res = await this.$https.upload({ download: file })
      console.log('retro==>', res)
      if (res.status === 200) {
        if (res.data.status === 1) {
          console.log('retro==>', res.data.savename)
          this.form.zs = res.data.savename
          this.form.zs_name = res.data.info
          this.$forceUpdate()
        } else {
          return this.$message.error(res.data.msg)
        }
      } else {
        return this.$message.error(res.data.msg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.tupian{
  width: 50px;
  height: 50px;
  object-fit: contain;
}
.upload-box{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .file-box{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-left: 18px;

    .name{
      width: 110px;
      font-family: PingFang;
      font-weight: bold;
      font-size: 14px;
      color: #999999;
      line-height: 18px;
      margin-left: 12px;
      word-wrap: break-word;
    }
  }

    .word{
      font-family: PingFang;
      font-weight: bold;
      font-size: 14px;
      color: #006ED1;
      line-height: 31px;
      margin-right: 16px;
      cursor: pointer;
    }
}
.result-box{
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fafafa;
  padding: 20px 0px;

  .reason {
    width: 100%;
    margin-top: 20px;
    margin-left: 284px;
    color: #999;
  }

  .box{
    width: 859px;
    height: 81px;
    line-height: 81px;
    background: #FFF7F9;
    border-radius: 2px;
    border: 2px solid #FDCAD7;
    margin-top: 15px;
    position: relative;
    padding-left: 32px;
    font-family: PingFang;
    font-weight: bold;
    font-size: 18px;
    color: #666666;

    display: flex;
    flex-direction: row;
    align-items: center;

    &.success{
      background: #F7FBFF;
      border: 2px solid #CAE3FD;
    }

    .word{
      margin-left: 10px;
    }

    .img{
      position: absolute;
      right: 17px;
      top: -33px;
    }
  }
}
  .section_11 {
    padding: 20px 0 16px;
    background-color: #fafafa;
    border-radius: 2px;
    width: 276px;
    height: 104px;
    border-left: dashed 2px #999999;
    border-right: dashed 2px #999999;
    border-top: dashed 2px #999999;
    border-bottom: dashed 2px #999999;
    position: relative;
    overflow: hidden;

    .upload{
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      // visibility: hidden;
      z-index: 10;
      opacity: 0;
    }

    .image_5 {
      width: 40px;
      height: 40px;
    }
    .text_20 {
      color: #666666;
      line-height: 16px;
    }
  }
  .group_10 {
    margin-top: 37px;
    width: 1076px;
    .group_11 {
      padding: 0 142px;
      .image_2 {
        width: 64px;
        height: 65px;
      }
      .image_4 {
        width: 253px;
        height: 2px;
      }
      .image_3 {
        width: 65px;
        height: 65px;
      }
    }
    .text_16 {
      margin-left: 143px;
      line-height: 16px;
      margin-top: 9px;
    }
    .text_17 {
      line-height: 16px;
      margin-left: 8px;
      margin-top: 9px;
    }
    .text_18 {
      margin-right: 143px;
      position: relative;
      left: 9px;
      margin-top: 9px;
    }
    .group_12 {
      padding: 5px 0 22px;
      .section_10 {
        padding: 38px 25px 40px 31px;
        background-color: #fafafa;
        .group_13 {
          display: flex;
          flex-direction: column;

          &.block2{
            margin-top: 144px;
            padding-top: 20px;
          }

          .row{
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            margin-top: 0px;

            .key{
              width: 148px;
              text-align: right;
            }

            .value{
              width: 537px;
              height: 35px;
              margin-left: 10px;

              /deep/ input{
                height: 35px;
                line-height: 35px;
                border: 2px solid #CAE3FD;
              }

              /deep/ textarea{
                width: 859px;
                border: 2px solid #CAE3FD;
                resize: none;
              }
            }
          }
        }
        .group_14 {
          margin-top: 19px;
          padding: 0 49px;
        }
        .text-wrapper_2 {
          padding: 10px 0;
          border-radius: 2px;
          background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=ef687600ce72699cda5051aff902c3ea.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          width: 538px;
          height: 36px;
          .text_20 {
            margin-left: 19px;
          }
        }
        .group_15 {
          margin-top: 18px;
          padding: 0 33px;
        }
        .group_16 {
          margin-top: 19px;
          padding: 0 64px;
        }
        .group_17 {
          padding: 0 81px;
          .image-wrapper {
            padding: 17px 0 14px;
            border-radius: 2px;
            background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=ef687600ce72699cda5051aff902c3ea.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            width: 538px;
            height: 36px;
            .image_5 {
              margin-right: 15px;
              width: 9px;
              height: 5px;
            }
          }
        }
        .view {
          margin-top: 18px;
        }
        .view_2 {
          margin-top: 19px;
        }
        .group_18 {
          margin-top: 25px;
          .text_21 {
            margin-top: 8px;
          }
          .image_6 {
            border-radius: 2px;
            width: 861px;
            height: 114px;
          }
        }
      }

    }
  }
  .font_7 {
    font-size: 15px;
    font-family: PingFang;
    line-height: 15px;
    color: #999999;
  }
  .section_12 {
    margin-right: 244px;
    padding: 39px 48px 44px;
    background-color: #fafafa;
    .group_19 {
      padding: 0 17px;
      .text_22 {
        line-height: 16px;
      }
    }
    .text-wrapper_3 {
      padding: 10px 0;
      border-radius: 2px;
      background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=c97a8fef57de3b6c3dd79ee9fbfdce0a.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      width: 538px;
      height: 36px;
      .text_23 {
        margin-left: 19px;
        line-height: 16px;
      }
      .text_24 {
        margin-left: 19px;
      }
    }
  }
  .group_20 {
    display: flex;
    flex-direction: row;
    justify-content: center;
    z-index: 10;
    margin-top: 40px;
    .section_13 {
      padding: 8px 14px;
      background-color: #0071d6;
      border-radius: 2px;
      width: 94px;
      height: 32px;
      cursor: pointer;
      .image_7 {
        width: 17px;
        height: 16px;
      }
    }
    .text-wrapper_4 {
      padding: 8px 0;
      background-color: #0071d6;
      border-radius: 2px;
      width: 94px;
      height: 32px;
      margin-left: 32px;
      cursor: pointer;
    }
    .font_8 {
      font-size: 13px;
      font-family: Alibaba;
      letter-spacing: 2.5px;
      color: #ffffff;
      margin-left: 9px;
    }
    .font_9 {
      font-size: 13px;
      font-family: Alibaba;
      letter-spacing: 2.5px;
      color: #ffffff;
    }
  }

.btn {
  width: 100%;
  text-align: center;
  margin-top: 20px;
  span{
    background-color: #0071d6;
    border-radius: 2px;
    color: #ffffff;
    font-size: 13px;
    letter-spacing: 2.5px;
    padding: 10px 18px;
    display: inline-block;
    cursor: pointer;
  }
}
</style>
